import React from 'react';
import { Typography } from '@guildeducationinc/recess';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { EducationRequirements } from 'src/components/ProgramDetails/Requirements/EducationRequirements';
import { LocationRequirements } from 'src/components/ProgramDetails/Requirements/LocationRequirements';
import { OtherRequirements } from 'src/components/ProgramDetails/Requirements/OtherRequirements';
import { Skeleton } from 'src/components/UserFacetSkeletonLoader';
import { SkillsAndWorkRequirements } from 'src/components/ProgramDetails/Requirements/SkillsAndWorkRequirements';
import { TechnologyRequirements } from 'src/components/ProgramDetails/Requirements/TechnologyRequirements';
import styles from './Requirements.module.scss';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
	loading: boolean;
}

export const Requirements: React.FC<Props> = ({ program, loading }) => {
	const { contentItems, requirements, shortProgramKind } = program;

	if (!contentItems && !requirements) {
		return null;
	}

	return (
		<section
			aria-label='requirements'
			className={styles.sectionContainer}
			data-testid='program-detail-requirements'
			data-title='Requirements'
			id='detail-requirements'
			tabIndex={-1}
		>
			<Typography className={styles.title} variant='h2'>
				What you need before you apply
			</Typography>
			<Skeleton dataLoading={loading} height={172}>
				<EducationRequirements
					programId={program.id}
					requirements={requirements}
					shortProgramKind={shortProgramKind}
				/>
				<SkillsAndWorkRequirements programContentItems={contentItems} />
				<TechnologyRequirements programContentItems={contentItems} />
				<LocationRequirements programContentItems={contentItems} />
				<OtherRequirements programContentItems={contentItems} programId={program.id} />
			</Skeleton>
		</section>
	);
};
